import { InfoModal } from "@newsela/angelou";
import React from "react";

import { IPageViewModelStandard } from "@/types/models/ContentPageViewModel.interface";
import {
  rootCss,
  modalContentWrapperCss,
  standardWrapperCss,
  standardNameCss,
  standardDescriptionCss,
  hideFooterCss,
} from "./GeniusStandardsModal.style";

interface GeniusStandardsModalProps {
  standards: IPageViewModelStandard[];
  standardsLabel: string;
  setActive: (active: boolean) => void;
  modalProps: any;
}

const GeniusStandardsModal: React.FC<GeniusStandardsModalProps> = ({
  standards,
  standardsLabel,
  setActive,
  modalProps,
}) => {
  return (
    <InfoModal
      labelId="Standards"
      onBackgroundClick={() => setActive(false)}
      title={standardsLabel}
      __cssFor={{
        root: rootCss,
        modalContentWrapper: modalContentWrapperCss,
        footer: hideFooterCss,
      }}
      {...modalProps}
    >
      {standards.map((standard) => {
        return (
          <div css={standardWrapperCss} key={standard.id}>
            <h3 css={standardNameCss}>{standard.name}</h3>
            <p css={standardDescriptionCss}>{standard.description}</p>
          </div>
        );
      })}
    </InfoModal>
  );
};

export default GeniusStandardsModal;
